module.exports = __webpack_public_path__ + "img/home-decor-3.d5b55735.jpg";